const cardAvailibility = {
    "AMEX": [
        "AX", "AL", "AS", "AD", "AU", "AT", "BE", "BR", "CA", "CL", "CX", "CC", "CO", "HR", "CY", "EC", "SV", "EE", "FK", "FI", "FR", "PF", "TF", "GI", "GR", "GU", "GG", "HK", "IN", "IE", "IM", "IT", "JP", "JE", "KI", "LV", "LT",
        "LU", "MT", "MH", "MQ", "YT", "MX", "FM", "MC", "ME", "NR", "NL", "NF", "MP", "PW", "PE", "PT", "RE", "SH", "MF", "SM", "SG", "SK", "ZA", "GS", "ES", "TL", "TC", "TV", "AE", "GB", "US", "VA", "VG", "VI",
    ]
}

export const additionalCardValidation = async (callbackData, countryCode) => {
    if (callbackData.brand === "AMERICAN EXPRESS" || callbackData.brand === "AMEX") {
        return cardAvailibility["AMEX"].includes(countryCode);
    } else {
        return true;
    }
};

// Every Flywire charge carries a `booking_reference` shaped "<TYPE>-<id>", stamped by
// whichever endpoint raised it (routes/api/flywire.js) and echoed back on the webhook.
// The prefix is the only record of *how* a payment was taken — one booking on its own, a
// whole cart in a single payment, a quotation, a monthly invoice — so the admin payment
// history reads it back to flag each charge.
export const CHARGE_METHOD_LABELS = {
    CB: "Charge Booking",
    CBE: "Charge Booking (Admin Edit)",
    CBEF: "Charge Edited Fee",
    CC: "Charge Cart",
    CEB: "Charge Edited Booking",
    AF: "Additional Fee",
    CQ: "Charge Quotation",
    CIV: "Charge Invoice",
};

const referenceFromWebhook = (webhookRequest) =>
    webhookRequest?.data?.fields?.booking_reference || "";

// The outgoing request is persisted as a JSON string of the exact body sent to Flywire,
// so the reference sits under recipient.fields.
const referenceFromChargeRequest = (chargeRequest) => {
    if (!chargeRequest) return "";
    try {
        const parsed = typeof chargeRequest === "string" ? JSON.parse(chargeRequest) : chargeRequest;
        const field = parsed?.recipient?.fields?.find((item) => item?.id === "booking_reference");
        return field?.value || "";
    } catch (err) {
        return "";
    }
};

// The webhook is authoritative but only exists once Flywire has answered; until then the
// request we sent carries the same reference.
export const getChargeReference = ({ webhookRequest, chargeRequest } = {}) =>
    referenceFromWebhook(webhookRequest) || referenceFromChargeRequest(chargeRequest);

// "CC-64f2…" -> { code: "CC", label: "Charge Cart", reference: "CC-64f2…" }.
// Null when there is no reference yet, or the prefix is one we have no name for — the
// payment history then shows no flag rather than inventing one.
export const getChargeMethod = (source) => {
    const reference = getChargeReference(source);
    if (!reference) return null;

    const code = String(reference).split("-")[0].toUpperCase();
    const label = CHARGE_METHOD_LABELS[code];

    return label ? { code, label, reference } : null;
};
